module.exports = __webpack_public_path__ + "img/bg45.6c673de4.png";